// this list contains all indexes that are relevant for each open tab/instance
const DB_PREFIXES = ["events"];

export const getAllDbNames = (editLock) => {
  return DB_PREFIXES.map((prefix) => `state-${prefix}-${editLock}`);
};
